var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 32,
    width: 52,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#ddd",
    d: "m293.58408,237.38805c-0.3945,-0.37805 -0.86874,-0.56705 -1.42267,-0.56705l-20.14676,0c-0.55401,0 -1.02816,0.18896 -1.42292,0.56705c-0.39455,0.37813 -0.59173,0.83251 -0.59173,1.36346l0,14.67276c0,0.53108 0.19718,0.9855 0.59173,1.36359c0.39476,0.37809 0.86891,0.56714 1.42292,0.56714l20.14676,0c0.55393,0 1.02813,-0.18905 1.42267,-0.56714c0.3945,-0.37805 0.59194,-0.83246 0.59194,-1.36359l0,-14.67276c0,-0.53095 -0.19744,-0.98533 -0.59194,-1.36346zm-1.01996,16.03652c0,0.10473 -0.03983,0.19496 -0.11957,0.27162c-0.07969,0.07608 -0.17416,0.11424 -0.28314,0.11424l-20.14676,0c-0.10906,0 -0.20353,-0.03816 -0.28327,-0.11453c-0.07969,-0.07663 -0.1196,-0.1669 -0.1196,-0.27163l0,-7.33627l20.95238,0l0,7.33657l-0.00004,0zm0,-11.9703l-20.95239,0l0,-2.70293c0,-0.10456 0.03978,-0.19487 0.11961,-0.27145c0.07978,-0.07621 0.17425,-0.11445 0.28327,-0.11445l20.14676,0c0.10898,0 0.20345,0.03807 0.28314,0.11445c0.07974,0.07658 0.11956,0.16689 0.11956,0.27145l0,2.70293l0.00005,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ddd",
    height: 1.545,
    width: 3.223,
    y: 250.721,
    x: 273.224
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ddd",
    height: 1.545,
    width: 4.835,
    y: 250.721,
    x: 278.059
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#ddd",
    d: "m48.020933,2.632812c-0.76981,-0.541231 -1.695221,-0.811811 -2.776135,-0.811811l-39.313497,0c-1.081071,0 -2.006306,0.270523 -2.776623,0.811811c-0.769907,0.541346 -1.154676,1.191854 -1.154676,1.951983l0,21.006097c0,0.760315 0.384768,1.41088 1.154676,1.952169c0.770317,0.541288 1.695553,0.81194 2.776623,0.81194l39.313497,0c1.080915,0 2.006247,-0.270651 2.776135,-0.81194c0.76981,-0.541231 1.155086,-1.191782 1.155086,-1.952169l0,-21.006097c0,-0.760129 -0.385276,-1.410637 -1.155086,-1.951983zm-1.990305,22.95851c0,0.149936 -0.077723,0.279112 -0.233324,0.388862c-0.155504,0.108919 -0.339848,0.16355 -0.552507,0.16355l-39.313497,0c-0.212815,0 -0.397159,-0.054631 -0.552761,-0.163966c-0.155504,-0.109707 -0.233382,-0.238941 -0.233382,-0.388876l0,-10.502891l40.885549,0l0,10.503321l-0.000078,0zm0,-17.13715l-40.885568,0l0,-3.86962c0,-0.149692 0.077625,-0.278984 0.233402,-0.388618c0.155679,-0.109105 0.340024,-0.163851 0.552761,-0.163851l39.313497,0c0.212659,0 0.397003,0.054503 0.552507,0.163851c0.155601,0.109635 0.233304,0.238926 0.233304,0.388618l0,3.86962l0.000098,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ddd",
    height: 2.211,
    width: 6.29,
    y: 21.721,
    x: 8.29
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#ddd",
    height: 2.211,
    width: 9.435,
    y: 21.721,
    x: 17.726
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.62168f9d84795064363f205b7e97f5cc.svg";
export { ForwardRef as ReactComponent };